import {
   ApiResponse,
   createApiRequest,
   getHeaderFromSessionStorage,
   Header,
} from "."
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import { UserTenant, BaseUser } from "@/types/user"

export interface UserResponse extends BaseUser {
   id: string
   tenants: UserTenant[]
}

export async function requestUser(): Promise<ApiResponse<UserResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.USER}`,
      HttpMethods.GET
   )
   return response
}

export async function requestUserToken(): Promise<
   ApiResponse<{ rtsToken: string }>
> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.USER_TOKEN}`,
      HttpMethods.GET,
      undefined,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
